import React from 'react';

interface ScanErrorsPanelProps {
  errors: string[];
}

export default function ScanErrorsPanel({ errors }: ScanErrorsPanelProps) {
  if (!errors || errors.length === 0) return null;

  return (
    <section className="scan-errors-panel" role="alert">
      <h3 className="scan-errors-panel__title">Scan errors</h3>
      <ul className="scan-errors-panel__list">
        {errors.map((err, idx) => (
          <li key={idx}>{err}</li>
        ))}
      </ul>
    </section>
  );
}
